import { ImisResponseItems, GenTableItem } from "../models/imis.models";
import { RestUtility } from "./rest.utility";

export class GenTablesUtility {

    private static readonly endpoint: string = "/api/gentable";

    public static async getAllGenTables(): Promise<string[]> {
        let genTables: string[] = [];

        try {
            genTables = await RestUtility.restApiSendData<string[]>(`${this.endpoint}/_execute`, {
                "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
                "OperationName": "GetGenTableNames",
            });
        } catch (error) {
            genTables = null;
        }

        return genTables;
    }

    public static getAllGenTableRecordsByTableName(tableName: string): Promise<ImisResponseItems<GenTableItem>> {
        return RestUtility.restApiGetDataAll<GenTableItem>(this.endpoint, { tableName });
    }

    public static getGenTableRecord(tableName: string, code: string): Promise<GenTableItem> {
        return RestUtility.restApiGetData<GenTableItem>(`${this.endpoint}/~${tableName}|${code}`);
    }

    public static addGenTableRecord(recordData: any): Promise<GenTableItem> {
        return RestUtility.restApiSendData(this.endpoint, recordData);
    }

    public static updateGenTableRecord(tableName: string, code: string, recordData: any): Promise<GenTableItem> {
        return RestUtility.restApiSendData(`${this.endpoint}/~${tableName}|${code}`, recordData, "PUT");
    }
}